import {
  CountryIso2,
  defaultCountries,
  parseCountry,
  usePhoneInput,
  FlagImage,
  CountryData,
} from "react-international-phone";
import { Input } from "@/components/ui/input";
import {
  Select,
  SelectContent,
  SelectTrigger,
  SelectValue,
  SelectItem,
} from "@/components/ui/select";
import { FormControl } from "@/components/ui/form";
import "react-international-phone/style.css";
import { useCountries } from "@/hooks/Countries";
import * as React from "react";

type CustomPhoneInputProps = {
  value: string;
  onChange: (phone: string) => void;
  allowAllCountries?: boolean;
};

export const CustomPhoneInput = React.forwardRef<
  HTMLInputElement,
  CustomPhoneInputProps
>(({ value, onChange, allowAllCountries = false }, ref) => {
  const { countries } = useCountries();

  const allowedCountries: CountryData[] = allowAllCountries
    ? defaultCountries
    : countries
    ? defaultCountries.filter((dc) => {
        const parsed = parseCountry(dc);
        const isAvailable = countries.some(
          (country) => country.code?.toLowerCase() === parsed.iso2.toLowerCase()
        );
        return isAvailable;
      })
    : defaultCountries; // Use all default countries while loading

  const { inputValue, handlePhoneValueChange, inputRef, country, setCountry } =
    usePhoneInput({
      defaultCountry: "au",
      value,
      // countries: defaultCountries,
      countries: allowedCountries,
      onChange: (data) => onChange(data.phone),
    });

  return (
    <div className="flex gap-2 w-full items-center">
      <FormControl>
        <Select
          value={country?.iso2}
          onValueChange={(val) => setCountry?.(val as CountryIso2)}
        >
          <SelectTrigger className="w-80] bg-brand-neutral-800">
            <SelectValue>
              {country?.iso2 && (
                <FlagImage
                  iso2={country.iso2}
                  style={{ display: "inline-block" }}
                />
              )}
            </SelectValue>
          </SelectTrigger>
          <SelectContent className="max-h-[300px] overflow-auto">
            {/* {defaultCountries.map((c) => { */}
            {allowedCountries.map((c) => {
              const parsed = parseCountry(c);
              return (
                <SelectItem key={parsed.iso2} value={parsed.iso2}>
                  <div className="flex items-center gap-2">
                    <FlagImage iso2={parsed.iso2} />
                    <span>{parsed.name}</span>
                    <span className="text-gray-500 ml-auto">
                      +{parsed.dialCode}
                    </span>
                  </div>
                </SelectItem>
              );
            })}
          </SelectContent>
        </Select>
      </FormControl>

      <FormControl className="flex-1">
        <Input
          type="tel"
          placeholder="Phone number"
          value={inputValue}
          onChange={handlePhoneValueChange}
          ref={ref || inputRef}
          className="bg-brand-neutral-800"
        />
      </FormControl>
    </div>
  );
});

CustomPhoneInput.displayName = "CustomPhoneInput";
